import * as React from "react";
import * as ReactDOM from "react-dom";
// import { Link } from "react-router-dom";
import SearchBoxDebounced from "../../components/SearchBoxDebounced";
import { convertUnixToDate } from "../../utils/datetime";
const algoliasearch = require("algoliasearch/lite");
const qs = require("qs");

import {
	InstantSearch,
	Hits,
	Highlight,
	Snippet,
	RefinementList,
	NumericMenu,
	Stats,
	Pagination,
	Configure,
	HierarchicalMenu,
	ClearRefinements,
	Menu,

	connectCurrentRefinements,
	connectRefinementList,
	connectNumericMenu,
	connectHierarchicalMenu,
	connectStateResults,
	connectMenu,
	connectHits,
} from "react-instantsearch-dom";

interface ResultProps {
	isSaved?: boolean;

	hit: {
		objectID;
		name: string;
		slug: string;
		url?: string;
		applicationFormUrl?: string;
		providedBy?: string;
		providerUrl?: string;
		providerLogo?: string;
		providerName?: string;
		providerType?: string;
		studyLevels?: string[];
		eligibleRegions?: string[];
		eligibleEthnicities?: string[];
		value?: number;
		valueDescription?: string;
		subjectOrFaculty?: string;
		closeDate?: number;
		openDate?: number;
		closeDateSemesterA?: number;
		closeDateSemesterB?: number;
		closeDateSemesterT?: number;
		domesticOrInternational?: string;
		tenure?: string; // number?
		tenureDescription?: string;
		numberAvailable?: number;
		isAlwaysOpen?: boolean;
		_highlightResult: {
			name: {
				value: string;
			}
		}
		_snippetResult: {
			description: {
				value: string;
			}
		}
	}
}

interface ResultState {
}

// TODO: util function...
const formatMoney = (amount, decimalCount = 0, decimal = ".", thousands = ",") => {
	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

		const negativeSign = amount < 0 ? "-" : "";

		let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount));
		let is = i.toString();
		let j = (is.length > 3) ? is.length % 3 : 0;

		return negativeSign + (j ? is.substr(0, j) + thousands : '') + is.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
	} catch (e) {
		console.log(e);
		return amount;
	}
};

class Result extends React.Component<ResultProps, ResultState> {
	render() {
		const hit = this.props.hit;
		let isExternalLink = false;

		const hasValidValueDescription = (hit.valueDescription && hit.valueDescription.length <= 100);
		const hasValidValue = hit.value && hit.value > 0;

		const value = hasValidValueDescription
			? hit.valueDescription
			: hasValidValue
				? formatMoney(hit.value)
				: 0;

		// converted close date for display
		let closeDateDisplay;
		// converted close date to a Date type
		let closeDate;
		let isAlwaysOpen = hit.isAlwaysOpen;

		if (hit.closeDate) {
			try {
				closeDateDisplay = convertUnixToDate(hit.closeDate).toLocaleDateString("en-US", {
					year: 'numeric',
					month: 'long',
					day: 'numeric'
				});
			}
			catch {
				console.error("Couldn't format the close date");
			}

			try {
				closeDate = convertUnixToDate(hit.closeDate);
			} catch {
				console.error("Couldn't format the close date");
			}
		}

		// isOpen compares the date timestamp to the current date time
		const isOpen = isAlwaysOpen || (closeDate && closeDate > Date.now());

		let url = `/scholarships/${hit.objectID}/${hit.slug}`;
		let providerUrl = hit.providerUrl;
		let clickTrack = () => {};

		if ((hit as any).urlOverride) {
			url = (hit as any).urlOverride;
			providerUrl = (hit as any).urlOverride;
		}

		if ((hit as any).clickTrackingLink) {
			clickTrack = () => {
				if ("sendBeacon" in navigator) {
					navigator.sendBeacon((hit as any).clickTrackingLink);
				}
			}
		}

		if ((hit as any).isPromoted) {
			isExternalLink = !hit.url?.includes("studyspy.ac.nz");
		}

		return (
			<div className="flex flex-column h-100" style={{ justifyContent: "space-between" }}>
				<div>
					<div className="dt w-100">
						<h2 className="dtc w-90 ma0 fw5 v-top mt2">
							<a
								className="db mh3 link underline-hover brand-font"
								href={url}
								onClick={clickTrack}
								style={{ fontSize: 19, lineHeight: 1.3, fontWeight: 600 }}
							>
								{hit.name}
							</a>
						</h2>
					</div>

					{(hit as any).isPromoted &&
						<div
							title={(hit as any).score}
							className="default f7 ttu tc dib lh-solid br2 mt2 black-50 bg-black-05 ph2 pv1 ml3"
						>
							Promoted
						</div>
					}

					{hit.providerName &&
						<div className="dt w-100" style={{ height: "72px" }}>
							{hit.providerLogo &&
								<div className="dtc v-mid pa2 pl3" style={{ width: "48px" }}>
									<a className="br2 bg-white pa1 ba b--black-05 db" href={providerUrl} onClick={clickTrack}>
										<div className="center tc flex items-center justify-center" style={{ width: "42px", height: "42px" }}>
											<img src={hit.providerLogo} alt="" style={{ maxHeight: "42px", maxWidth: "42px" }} />
										</div>
									</a>
								</div>
							}
							<div className={`dtc pa3 ${hit.providerLogo ? "pl2" : "pl3" }`}>
								<a href={providerUrl} onClick={clickTrack}>
									<h3 className="mt1 dib f6 fw5 black-80 lh-title mb0">
										{hit.providerName}
									</h3>
								</a>
								<div className="mt1" style={{ color: "#777", fontSize: "12px" }}>
									{hit.providerType}
								</div>
							</div>
						</div>
					}

					{isOpen &&
						<div
							className="default f7 ttu tc dib lh-solid br2 mb2 ph2 pv1 ml3"
							style={{ backgroundColor: "#C8E6C9", color: "#43A047" }}
						>
							Open
						</div>
					}

					{!isOpen &&
						<div
							className="default f7 ttu tc dib lh-solid br2 mb2 ph2 pv1 ml3"
							style={{ backgroundColor: "#FFCDD2", color: "#E53935" }}
						>
							Closed
						</div>
					}

					<div className="ph3">
						<table
							className={`collapse w-100 f6 lh-title pt3 ${hit.providerName ? "" : "mt3"}`}
							style={{tableLayout: "fixed", captionSide: "bottom"}}
						>
							<caption className="clip">{hit.name}</caption>
							<tbody>
							{!!value &&
								<tr className="bt b--black-05">
									<th className="pl1 pr3 pv1 ttu f7 black-60 v-top" scope="row">Value</th>
									<td className="pr1 pv1">{hasValidValueDescription ? value : "$" + value}</td>
								</tr>
							}
							{!!(hit.studyLevels && hit.studyLevels.length && hit.studyLevels[0]) &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60" scope="row">Study levels</th>
									<td className="pr1 pv1">{hit.studyLevels.join(", ")}</td>
								</tr>
							}
							{!!(hit.eligibleRegions && hit.eligibleRegions.length > 0 && hit.eligibleRegions[0]) &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60" scope="row">Locations</th>
									<td className="pr1 pv1">{hit.eligibleRegions.join(", ")}</td>
								</tr>
							}
							{!!(hit.eligibleEthnicities && hit.eligibleEthnicities.length && hit.eligibleEthnicities[0]) &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60" scope="row">Ethnicities</th>
									<td className="pr3 pv1">{hit.eligibleEthnicities.join(", ")}</td>
								</tr>
							}
							{/*!!hit.OpenDate &&
										<tr className="bt b--black-05">
											<th className="ph3 pv1 ttu f7 black-60" scope="row">Open date</th>
											<td className="pr3 pv1">{hit.OpenDate}</td>
										</tr>
									}
									{/*!!(hit.CloseDate || hit.CloseDateSemesterA || hit.CloseDateSemesterB || hit.CloseDateSemesterT) &&
										<tr className="bt b--black-05">
											<th className="ph3 pv1 ttu f7 black-60" scope="row">Close date</th>
											<td className="pr3 pv1">{
												hit.CloseDate ||
												hit.CloseDateSemesterA ||
												hit.CloseDateSemesterB ||
												hit.CloseDateSemesterT
											}</td>
										</tr>
										*/}
							{!!(hit.tenure || hit.tenureDescription) &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60 v-top" scope="row">Length</th>
									<td className="pr1 pv1">{hit.tenure || hit.tenureDescription}</td>
								</tr>
							}
							{!!isAlwaysOpen &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60 v-top" scope="row">Application Date</th>
									<td className="pr1 pv1">Open Year Round for Applications</td>
								</tr>
							}
							{/*!!hit.NumberAvailable &&
										<tr className="bt b--black-05">
											<th className="ph3 pv1 ttu f7 black-60" scope="row">Number available</th>
											<td className="pr3 pv1">{hit.NumberAvailable}</td>
										</tr>
									*/}
							{(!!closeDateDisplay && !isAlwaysOpen) &&
								<tr className="bt b--black-05">
									<th className="pl1 pv1 ttu f7 black-60 v-top" scope="row">Closing date</th>
									<td className="pr1 pv1">{closeDateDisplay}</td>
								</tr>
							}
							</tbody>
						</table>
					</div>

					<div className="bt b--black-05 mh3" />

					<div className="ma3 pv2">
						<Snippet
							className="f6 black-80 lh-copy"
							attribute="description"
							hit={hit}
						/>
						{(hit as any).isPromoted ? "" : "..."}
					</div>

					{!!((hit as any).isPromoted) &&
						<a
							href={(hit as any).url}
							onClick={clickTrack}
							style={{ marginTop: "auto" }}
							className="db link white bg-brand-blue mh3 mb3 ph3 pv2 br2 tc dim"
							target={isExternalLink ? "_blank" : undefined}
						>
							Learn more
						</a>
					}

					{/* Tracking pixel */}
					{!!(hit as any).viewTrackingPixel &&
						<img
							style={{ height: 0, width: 0, overflow: "hidden", position: "absolute" }}
							src={(hit as any).viewTrackingPixel}
							width="1"
							height="1"
							alt=""
						/>
					}
				</div>
			</div>
		);
	}
}

interface FilterProps {
	label: string;
	refine?(x?);
	isRefined: boolean;
	currentRefinement?: string[] | string;
	canRefine?: boolean;
	items?: {
		count: number;
		isRefined: boolean;
		label: string;
		value: any; // probably an array
	}[];
	clear(x?);
}

interface FilterState {
	isOpen: boolean;
}

class Filter extends React.Component<FilterProps, FilterState> {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	open = () => {
		this.setState({ isOpen: true });
		document.body.classList.add("modal-open");
	}

	close = () => {
		this.setState({ isOpen: false });
		document.body.classList.remove("modal-open");
	}

	render() {
		const canRefine = this.props.canRefine;

		return (
			<div className="dib mr2 mt2">
				<div
					className={`${canRefine ? "pointer" : "black-50" } dt w-100 brand-font ba b--black-10 f6 ${this.props.isRefined ? "bg-brand-blue white" : "bg-white black-80"}`}
					onClick={canRefine ? this.open : () => {}}
					style={{ borderRadius: "4px" }}
				>
					<div className={`ma2 dtc v-mid ${canRefine ? "dim" : ""} ${this.props.isRefined ? "ph2" : "pa2"}`}>
						{this.props.label}
					</div>

					{this.props.isRefined &&
						<button
							className="b--white-10 dtc bg-transparent dim v-mid pa2 br2 white-90 pointer"
							style={{ width: "32px", height: "100%", borderStyle: "none none none solid", borderWidth: "1px" }}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								this.props.clear();
								// blur target, select X or view results?
							}}
						>
							<svg
								focusable="false"
								aria-label="Close"
								viewBox="0 0 32 32"
								width="14"
								height="14"
								fill="none"
								stroke="currentcolor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								style={{
									marginTop: "1px",
									marginBottom: "-2px"
								}}
							>
								<path d="M2 30 L30 2 M30 30 L2 2" />
							</svg>
						</button>
					}
				</div>
				{ReactDOM.createPortal(
					<div className="modal" style={{ display: this.state.isOpen ? "block" : "none" }}>
						<div
							className="modal__internals"
							aria-hidden="true"
							role="dialog"
							tabIndex={-1}
						>
							<div className="modal__body">
								<div className="modal__header">
									<div className="modal__close">
										<button
											className="modal__close__button"
											onClick={this.close}
										>
											<svg
												focusable="false"
												aria-label="Close"
												viewBox="0 0 32 32"
												width="15"
												height="15"
												fill="none"
												stroke="currentcolor"
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth="2"
											>
												<path d="M2 30 L30 2 M30 30 L2 2" />
											</svg>
										</button>
									</div>
									{this.props.isRefined &&
										<div className="modal__clear">
											<div className="modal__clear__internal">
												<button
													type="button"
													className="modal__clear__internal__button brand-blue"
													onClick={() => this.props.clear()}
												>
													<span>Clear</span>
												</button>
											</div>
										</div>
									}
								</div>

								<div className="modal__scroll">
									{this.props.children}
								</div>
							</div>

							<div className="modal__footer">
								<button
									type="button"
									className="modal__footer__button"
									onClick={this.close}
								>
									<span>View results</span>
								</button>
							</div>
						</div>
					</div>,
					document.getElementById("modal-container")
				)}
			</div>
		);
	}
}

/* REGION FILTER */
let RegionFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Location";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Locations (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

RegionFilter = connectRefinementList(RegionFilter);
/* REGION FILTER */


/* STUDY LEVEL FILTER */
let StudyLevelFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Study level";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Study levels (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

StudyLevelFilter = connectRefinementList(StudyLevelFilter);
/* STUDY LEVEL FILTER */

/* ETHNICITY FILTER */
let EthnicityFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Ethnicity";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Ethnicities (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

EthnicityFilter = connectRefinementList(EthnicityFilter);
/* ETHNICITY FILTER */

/* DOMESTIC/INTL FILTER */
let DomesticIntlFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Domestic/international";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

DomesticIntlFilter = connectRefinementList(DomesticIntlFilter);
/* DOMESTIC/INTL FILTER */

/* PROVIDER FILTER */
let ProviderFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Providers";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Providers (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				attribute={props.attribute}
			/>
		</Filter>
	);
};

ProviderFilter = connectRefinementList(ProviderFilter);

interface FiltersProps {

}

interface FiltersState {

}

class Filters extends React.Component<FiltersProps, FiltersState> {
	render() {
		return (
			<div className="search__filter-bar cf">
				<div className="search__filter-bar__content mw9-l center">
					<RegionFilter attribute="eligibleRegions" />
					<StudyLevelFilter attribute="studyLevels" />
					<ProviderFilter attribute="providerName" />
					{<EthnicityFilter attribute="eligibleEthnicities" />}
					{<DomesticIntlFilter attribute="domesticOrInternational" />}
				</div>
				<div className="search__filter-bar__blur" />
			</div>
		);
	}
}

const ConnectedFilters = connectCurrentRefinements(Filters);

const appId = window["__SEARCH_CONFIGURATION__"].appId;
const apiKey = window["__SEARCH_CONFIGURATION__"].apiKey;
const indexName = "scholarships";

/** AD CAMPAIGN PROMOTIONS **/
const promotions = window["__SEARCH_CONFIGURATION__"].promotions;
let adCampaignsPromotions;
let hitCountPromotion = 12; // 12 hits (default) if no promotion matches.
if (!!promotions) {
	promotions.sort((a, b) => b.priority - a.priority);
	adCampaignsPromotions = promotions.map(promotion => {
		return {
			keywords: promotion.keywords,
			negativeKeywords: promotion.negativeKeywords,
			promotionData: {
				id: promotion.id,
				objectID: promotion.id.toString(),
				providerId: promotion.providerId,
				providedBy: promotion.providerName,
				providerName: promotion.providerName,
				providerType: promotion.providerType,
				providerUrl: promotion.providerUrl,
				providerLogo: promotion.providerLogo,
				isPromoted: true,
				name: promotion.name,
				description: promotion.description,
				url: promotion.url,
				viewTrackingPixel: promotion.viewTrackingPixel,
				clickTrackingLink: promotion.clickTrackingLink,
				_snippetResult: {
					description: {
						value: promotion.description,
					},
				}
			}
		};
	});
}
/** END AD CAMPAIGN PROMOTIONS **/

// const scholPromotion = {
// 	hit: {
// 		"id": 11104,
// 		"slug": "trimester-2-2020fees-scholarship",
// 		"providerId": 258,
// 		"name": "Trimester 2, 2020—Fees Scholarship",
// 		"providedBy": "Victoria University of Wellington",
// 		"providerType": "University",
// 		"providerName": "Victoria University of Wellington",
// 		"providerUrl": "/providers/258/victoria-university-of-wellington",
// 		"providerLogo": "https://ucarecdn.com/905d64f1-42fb-4cc4-8c90-15836eb408fd/",
// 		"isPartOfNzist": false,
// 		"nzistUrl": "/scholarship/11104/trimester-2-2020fees-scholarship",
// 		"description": "A Trimester 2, 2020 Fees Scholarship, covering 100% of tuition fees, is offered by Te Herenga Waka—Victoria University of Wellington to people whose work and life has been disrupted by the COVID-19 pandemic. This is one of the ways in the University supports  its communities and the people of New Zealand at this time. This Scholarship is open to domestic students of all ages who meet the University’s academic entry requirements.",
// 		"entryRequirements": "",
// 		"tenureDescription": "One trimester",
// 		"valueDescription": "Tuition fees",
// 		"url": "https://www.wgtn.ac.nz/fees-scholarship?utm_source=studyspy&utm_medium=search&utm_campaign=2020_fees_scholarship",
// 		"closeDate": 1592179200, 1646010000
// 		"objectID": "11104",
// 		urlOverride: "https://www.wgtn.ac.nz/fees-scholarship?utm_source=studyspy&utm_medium=search&utm_campaign=2020_fees_scholarship",
// 		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=435260;plid=1183096;BID=519913590;wt=0;rnd=CACHE_BUSTER_MACRO",
// 		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1183096&setID=435260&channelID=0&CID=395197&banID=519913590&PID=0&textadID=0&tc=1&type=tclickcb&mt=1&hc=706a3f2838fa54b60dca517c9e0babddc4671d65&location=",
// 		isPromoted: true,
// 		_highlightResult: {
// 			name: {
// 				value: "Trimester 2, 2020—Fees Scholarship"
// 			},
// 			majors: [{
// 				matchLevel: "none",
// 				value: ""
// 			}]
// 		},
// 		_snippetResult: {
// 			description: {
// 				value: "A Trimester 2, 2020 Fees Scholarship, covering 100% of tuition fees, is offered by Te Herenga Waka—Victoria University of Wellington to people whose work and life has been disrupted by the COVID-19 pandemic. This is one of the ways in the University supports  its communities and the people of New Zealand at this time. This Scholarship is open to domestic students of all ages who meet the University’s academic entry requirements."
// 			}
// 		}
// 	}
// };

const scholPromotion1 = {
	hit: {
		"id": 99999997,
		"slug": "teach-nz-scholarships",
		"providerId": 415,
		"name": "Te Huarau Scholarship",
		"providedBy": "Teach NZ",
		"providerType": "Ministry of Education",
		"providerName": "Teach NZ",
		"providerUrl": "/providers/415/teachnz",
		"providerLogo": "https://ucarecdn.com/2c859a08-5ef9-49fb-9e3d-1d19d533e418/",
		"isPartOfNzist": false,
		"nzistUrl": "",
		"description": "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to.",
		"entryRequirements": "",
		"tenureDescription": "",
		"valueDescription": "Course fees, and an allowance of $10,000",
		"url": "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755493;dc_trk_aid=516247756;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		"closeDate": 1646010000,
		"objectID": "99999997",
		urlOverride: "https://www.teachnz.govt.nz/studying-to-be-a-teacher/scholarships/teachnz-te-huarau-scholarship/?utm_source=EDM&utm_medium=Display&utm_campaign=General-Scholarships&utm_content=DEMO",
		viewTrackingPixel: "",
		clickTrackingLink: "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755493;dc_trk_aid=516247756;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		isPromoted: true,
		_highlightResult: {
			name: {
				value: "Te Huarau Scholarship"
			},
			majors: [{
				matchLevel: "none",
				value: ""
			}]
		},
		_snippetResult: {
			description: {
				value: "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to."
			}
		}
	}
};

const scholPromotion2 = {
	hit: {
		"id": 99999998,
		"slug": "teach-nz-scholarships",
		"providerId": 415,
		"name": "Te Tipu Whakarito Scholarship",
		"providedBy": "Teach NZ",
		"providerType": "Ministry of Education",
		"providerName": "Teach NZ",
		"providerUrl": "/providers/415/teachnz",
		"providerLogo": "https://ucarecdn.com/2c859a08-5ef9-49fb-9e3d-1d19d533e418/",
		"isPartOfNzist": false,
		"nzistUrl": "",
		"description": "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to.",
		"entryRequirements": "",
		"tenureDescription": "",
		"valueDescription": "Course fees, and an allowance of $10,000",
		"url": "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755251;dc_trk_aid=516079443;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		"closeDate": 1646010000,
		"objectID": "99999998",
		urlOverride: "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755251;dc_trk_aid=516079443;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		viewTrackingPixel: "",
		clickTrackingLink: "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755251;dc_trk_aid=516079443;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		isPromoted: true,
		_highlightResult: {
			name: {
				value: "Te Tipu Whakarito Scholarship"
			},
			majors: [{
				matchLevel: "none",
				value: ""
			}]
		},
		_snippetResult: {
			description: {
				value: "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to."
			}
		}
	}
};

const scholPromotion3 = {
	hit: {
		"id": 99999999,
		"slug": "teach-nz-scholarships",
		"providerId": 415,
		"name": "Kupe Scholarships for Māori and Pacific High Achievers",
		"providedBy": "Teach NZ",
		"providerType": "Ministry of Education",
		"providerName": "Teach NZ",
		"providerUrl": "/providers/415/teachnz",
		"providerLogo": "https://ucarecdn.com/2c859a08-5ef9-49fb-9e3d-1d19d533e418/",
		"isPartOfNzist": false,
		"nzistUrl": "",
		"description": "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to.",
		"entryRequirements": "",
		"tenureDescription": "",
		"valueDescription": "Course fees, and an allowance of $15,000",
		"url": "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755248;dc_trk_aid=516079440;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		"closeDate": 1646010000,
		"objectID": "99999999",
		urlOverride: "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755248;dc_trk_aid=516079440;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		viewTrackingPixel: "",
		clickTrackingLink: "https://ad.doubleclick.net/ddm/trackclk/N524402.2485907EDM-NZ/B26933777.323755248;dc_trk_aid=516079440;dc_trk_cid=163418692;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd",
		isPromoted: true,
		_highlightResult: {
			name: {
				value: "Kupe Scholarships for Māori and Pacific High Achievers"
			},
			majors: [{
				matchLevel: "none",
				value: ""
			}]
		},
		_snippetResult: {
			description: {
				value: "If you want to learn, teach and inspire, now is your chance to become your own favourite kaiako. Apply now for a teaching  scholarship with all fees paid, plus a generous allowance while you study. Tau ke! Whatever your favourite subject, this is your opportunity to inspire yourself, and our tamariki – and become someone that you look up to."
			}
		}	}
};

// We do this so we can inject promoted courses in, without having to
// pay thousands of dollars to do more than 10.
const ConnectedHits =  connectHits(({ hits, searchState }) => {
	const { query } = searchState;

	// AD CAMPAIGN PROMOTIONS
	if (!!adCampaignsPromotions) {
		adCampaignsPromotions.forEach(promotion => {
			let matchTick = 0;
			let queryWords = (query || "").toLowerCase().split(" ");
			let existsKeywords = promotion.keywords.some(keyword => {
				let keywordWords = keyword.toLowerCase().split(" ");
				return keywordWords.every(word => queryWords.includes(word));
			});
			let existsInNegative = promotion.negativeKeywords.some(negativeKeyword => {
				let negativeKeywordWords = negativeKeyword.toLowerCase().split(" ");
				return negativeKeywordWords.every(word => queryWords.includes(word));
			});

			if (existsKeywords && !existsInNegative) {
				matchTick++;
				hits = [
					...promotion.promotionData,
					...hits
				];
			}
			hitCountPromotion = 12 - matchTick;
		});
	}
	// END AD CAMPAIGN PROMOTIONS

	return (
		<div className="ais-Hits">
			<ul className="ais-Hits-list">
				{hits.map(hit =>
					<li
						className={`ais-Hits-item ${hit.isPromoted ? "ais-Hits-item--promoted" : ""}`}
						key={hit.objectID + (hit.isPromoted ? "-ad" : "")}
					>
						<Result hit={hit} />
					</li>
				)}
			</ul>
		</div>
	);
});

const Results = connectStateResults((props) => {
	const {
		showSaved,
		hasSaved,
		savedCount,
		searchState,
		searchResults,
		searching,
		allSearchResults
	} = props;

	const hasResults = searchResults && searchResults.nbHits !== 0;
	const promoted: string[] = [];

	// So we can highlight the promoted courses (data isn't attached to the result)
	if (allSearchResults && allSearchResults.userData) {
		allSearchResults.userData.map(datum => {
			if (datum.promoted) {
				promoted.push(datum.promoted);
			}
		});
	}

	const FilterHelper = connectCurrentRefinements((props) => props.items.length ? <div>
		<p className="mh3 mt0 lh-copy black-60">
			Try clearing your filters to widen your search.
		</p>
		<ClearRefinements />
	</div>: null);

	if (hasResults) {
		// Force a recalculation of the web widget location
		if ((window as any).handleScroll) (window as any).handleScroll();

		return (
			<div className="mw9-l center ph2-l pb4">
				<Stats translations={{
					stats: (n, _ms) => {
						let result = `${n > 0 ? n.toLocaleString('en-NZ') : "No"} result${n == 1 ? "" : "s"}`

						if (searchState && searchState.query && searchState.query.length > 0) {
							result += ` for "${searchState.query}"`;
						}

						return result;
					}
				}} />

				<ConnectedHits
					searchState={searchState}
					promoted={promoted}
				/>

				<Pagination
					showLast={true}
					showFirst={true}
					padding={2}
					translations={{
						previous: "Previous",
						next: "Next",
					}}
				/>
			</div>
		);
	}
	else if (!searching) {
		return (
			<div className="tc pv4 pv5-l">
				<div className="f2">🤔</div>
				<div className="brand-font f3 lh-titl mt2">No results</div>
				<p className="measure-wide center db lh-copy black-60 mt2 tc ph3 mb0">
					We couldn't find anything{searchState.query && " for \"" + searchState.query + "\""}.
				</p>

				<FilterHelper />
			</div>
		);
	}
	else {
		return (
			<div className="tc pv4 pv5-l">
				<div className="brand-font f3 lh-titl mt2">Searching...</div>
			</div>
		);
	}
});

const createUrl = state => {
	if (!state) {
		return null;
	}

	return `?${qs.stringify(state, {
		skipNulls: true,
		strictNullHandling: true,
		filter: (prefix, value) => {
			if (prefix === "configure") {
				return;
			}

			return value;
		}
	})}`;
};

const searchStateToUrl = (props, searchState) => {
	// TODO: encode tag and location correctly

	if (searchState) {
		return `${props.location.pathname}${createUrl(searchState)}`;
	}

	return null;
};

const urlToSearchState = props => {
	let searchState = qs.parse(location.search.slice(1));

	if (props.match.params.tag) {
		// turn the tag query into an algolia-friendly query parameter
		// OR virtualmenu
	}

	if (!props.location || !props.location.search || !props.location.search.slice(1)) {
		return {};
	}

	return searchState;
}

interface SearchProps {
	location;
	history;
	match;
}

interface SearchState {
	searchState;
	showHero?: boolean;
}

export default class ScholarshipSearch extends React.Component<SearchProps, SearchState> {
	private debouncedSetState;
	private searchClient;

	constructor(props) {
		super(props);

		const searchState = urlToSearchState(props);

		let urlParams = new URLSearchParams(window.location.search);
		let hasQuery = urlParams.has('query');
		let isMobile = window.matchMedia("(max-width: 480px)").matches;

		this.state = {
			searchState,
			showHero: (!(isMobile || hasQuery)),
		};

		this.searchClient = algoliasearch(appId, apiKey);
	}

	componentWillReceiveProps(props) {
		if (props.location !== this.props.location) {
			this.setState({ searchState: urlToSearchState(props) });
		}
	}

	onSearchStateChange = searchState => {
		clearTimeout(this.debouncedSetState);

		this.debouncedSetState = setTimeout(() => {
			this.props.history.push(
				searchStateToUrl(this.props, searchState),
				searchState
			);
		}, 700);

		window.scrollTo(0, 0);
		this.setState({ searchState });
	}

	handleSubmit = query => {
		if (query) {
			// Permanently hidden if user submits a query.
			this.setState({ showHero: false }, () => {
				// Restore the query
				console.log(this.searchClient);
			});
		}
	}

	render() {
		const searchQuery = this.state.searchState.query ? `?query=${this.state.searchState.query}` : null;
		const heroImage = "https://ucarecdn.com/a523ba65-0ec6-4863-a21f-690c268e4adf/";

		return (
			<InstantSearch
				searchClient={this.searchClient}
				indexName={indexName}
				searchState={this.state.searchState}
				onSearchStateChange={this.onSearchStateChange}
				createURL={createUrl}
			>
				<Configure hitsPerPage={hitCountPromotion} />

				{this.state.showHero ? (
					<div className="bg-white">
						<div className="center pa3 pv5-ns mw9-l">
							<div className="flex flex-column-reverse dt-ns w-100">
								<div className="dtc v-mid w-66-ns">
									<h1 className="brand-font tc tl-ns fw7 lh-title f3 f1-ns mb0 brand-accent mt0">
										Discover scholarships.
									</h1>
									<p className="lh-copy tc tl-ns black-90 measure mt2 f5 f4-ns brand-font">
										Aotearoa's largest database of scholarships. Explore $70 million worth of&nbsp;opportunities in NZ.
									</p>

									<div className="tailwind">
										<div className="w-full">
											<SearchBoxDebounced
												delay={200}
												autoFocus
												showLoadingIndicator
												showButton
												placeholder="Search scholarships..."
												translations={{ placeholder: "Search scholarships..." }}
												onSubmit={this.handleSubmit}
												onChange={() => window.scrollTo(0, 0)}
											/>
										</div>
									</div>
								</div>
								<div className="db dtc-ns v-mid w-60 w-40-ns center tc tr-ns">
									<picture>
										<img src={heroImage}
											alt=""
											className="dib"
											style={{ maxWidth: "100%", maxHeight: "300px" }}
											srcSet={`${heroImage}-/resize/x320/-/format/jpg/-/quality/lighter/ 320w,
													${heroImage}-/resize/x450/-/format/jpg/-/quality/lighter/ 450w,
													${heroImage}-/resize/x640/-/format/jpg/-/quality/lighter/ 640w,
													${heroImage}-/resize/x750/-/format/jpg/-/quality/lighter/ 750w,
													${heroImage}-/resize/x800/-/format/jpg/-/quality/lighter/ 800w,
													${heroImage}-/resize/x900/-/format/jpg/-/quality/lighter/ 900w,
													${heroImage}-/resize/x1000/-/format/jpg/-/quality/lighter/ 1000w,
													${heroImage}-/resize/x1200/-/format/jpg/-/quality/lighter/ 1200w`}
											sizes="(min-width: 1000px) 50vw, 100vw" />
									</picture>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="tailwind">
						{ReactDOM.createPortal(
							<SearchBoxDebounced
								delay={200}
								autoFocus
								showLoadingIndicator
								placeholder="Search scholarships..."
								onSubmit={this.handleSubmit}
								translations={{ placeholder: "Search scholarships..." }}
								onChange={() => window.scrollTo(0, 0)}
							/>,
							document.getElementById("search-box-portal")
						)}
					</div>
				)}

				<div className="search__header">
					<ConnectedFilters />
				</div>

				<Menu attribute="tags" />

				<Results />
			</InstantSearch>
		);
	}
}
